export const FETCH_ALLCOUPONS_REQUEST = 'FETCH_ALLCOUPONS_REQUEST'
export const FETCH_ALLCOUPONS_SUCCESS = 'FETCH_ALLCOUPONS_SUCCESS'
export const FETCH_ALLCOUPONS_FALIURE = 'FETCH_ALLCOUPONS_FALIURE'
export const ADD_COUPON_REQUEST = 'ADD_COUPON_REQUEST'
export const ADD_COUPON_SUCCESS = 'ADD_COUPON_SUCCESS'
export const ADD_COUPON_FALIURE = 'ADD_COUPON_FALIURE'
